import { css } from '@emotion/react';
import { useEffect, useState } from 'react';

import NvGeneratingLoader from 'shared/components/loaders/nv-generating-loader';

const FADE_DURATION = 300; // ms
const STATUS_INTERVAL = 2000; // ms

const styles = css`
  min-height: 300px;
  .lh-25 {
    line-height: 25px;
  }
  .status-container {
    position: relative;
    height: 25px;
    width: 100%;
    text-align: center;
  }
  .status-text {
    position: absolute;
    left: 0;
    right: 0;
    transition: opacity ${FADE_DURATION}ms ease-in-out;
    &.fade-out {
      opacity: 0;
    }
    &.fade-in {
      opacity: 1;
    }
  }
`;

type AiGenerationPreviewProps = {
  aiGenerationTexts: string[];
};
const AiGenerationPreview = (props: AiGenerationPreviewProps) => {
  const { aiGenerationTexts = [] } = props;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (!aiGenerationTexts.length || currentIndex >= aiGenerationTexts.length - 1) return undefined;

    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const interval = setInterval(() => {
      // Start fade out
      setIsFading(true);

      // After fade out completes, change text and fade in
      timeoutId = setTimeout(() => {
        setCurrentIndex((prevIndex) => {
          if (prevIndex >= aiGenerationTexts.length - 1) {
            clearInterval(interval);
            return prevIndex;
          }
          return prevIndex + 1;
        });
        setIsFading(false);
      }, FADE_DURATION);
    }, STATUS_INTERVAL);

    return () => {
      clearInterval(interval);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [currentIndex, aiGenerationTexts]);

  return (
    <div className='d-flex flex-column align-items-center pt-6 pb-4' css={styles}>
      <NvGeneratingLoader className='mb-0 mt-4' />
      <div className='status-container mt-2'>
        <p className={`text-regular text-gray-2 lh-25 mb-0 status-text ${isFading ? 'fade-out' : 'fade-in'}`}>
          {aiGenerationTexts[currentIndex] ?? ''}
        </p>
      </div>
    </div>
  );
};

export default AiGenerationPreview;
